import { render, staticRenderFns } from "./SessionsOld.vue?vue&type=template&id=551a38c5"
import script from "./SessionsOld.vue?vue&type=script&lang=js"
export * from "./SessionsOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports